import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../services/api";
import "../styles/AuthPages.css";

function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate(); // Permet de rediriger après succès

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleResetPassword = async () => {
    setError("");
    setMessage("");

    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    try {
      // On envoie le token et le nouveau mot de passe au backend
      await API.post(`/users/reset-password/${token}`, { password });
      
      alert("Votre mot de passe a été modifié avec succès ! 🎉");
      navigate("/login"); // Redirection vers la page de connexion
    } catch (err) {
      setError(err.response?.data?.message || "Une erreur est survenue.");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Nouveau mot de passe</h1>
        
        {error && <div className="error-message" style={{color: "red", marginBottom: "10px"}}>{error}</div>}

        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <button onClick={handleResetPassword}>
          Mettre à jour le mot de passe
        </button>
      </div>
    </div>
  );
}

export default ResetPasswordPage;